import staticDataService from '../services/staticDataService';
export default staticDataService;
